export interface BackupRecord {
  id: string;
  /** UTC timestamp, used to make retention independent of the browser's locale. */
  createdAt: string;
  json: string;
}
export type BackupTier = "daily" | "weekly" | "monthly";
export interface RetainedBackup extends BackupRecord {
  tier: BackupTier;
}

const LIMITS: ReadonlyArray<[BackupTier, number]> = [
  ["daily", 7],
  ["weekly", 8],
  ["monthly", 12],
];

function weekOf(timestamp: string): string {
  const date = new Date(`${timestamp.slice(0, 10)}T00:00:00.000Z`);
  const weekdayFromMonday = (date.getUTCDay() + 6) % 7;
  date.setUTCDate(date.getUTCDate() - weekdayFromMonday);
  return date.toISOString().slice(0, 10);
}

/** Newest snapshot per calendar bucket. A record can cover more than one tier. */
export function retainedBackups(records: readonly BackupRecord[]): RetainedBackup[] {
  const newest = [...records].sort((a, b) => b.createdAt.localeCompare(a.createdAt) || b.id.localeCompare(a.id));
  const selected = new Map<string, RetainedBackup>();
  for (const [tier, limit] of LIMITS) {
    const buckets = new Set<string>();
    for (const record of newest) {
      const key = tier === "daily"
        ? record.createdAt.slice(0, 10)
        : tier === "weekly"
          ? weekOf(record.createdAt)
          : record.createdAt.slice(0, 7);
      if (buckets.has(key)) continue;
      if (buckets.size >= limit) break;
      buckets.add(key);
      if (!selected.has(record.id)) selected.set(record.id, { ...record, tier });
    }
  }
  return [...selected.values()].sort((a, b) => b.createdAt.localeCompare(a.createdAt) || b.id.localeCompare(a.id));
}
